import { Wrapper, IconWrapper } from './styles';
import { AlertProps } from './types';
import { InformationIcon } from '@slal/ui/icons';

export const Alert = ({ type, children }: AlertProps) => {
    return (
        <Wrapper type={type}>
            <IconWrapper>
                <InformationIcon color="#147CB3" />
            </IconWrapper>
            <div>{children}</div>
        </Wrapper>
    );
};
